import { EditorColorScheme } from '@nx-frontend/shared/types';

export interface Skeleton {
  theme: string;
  baseColor: string;
  waveColor: string;
}

// Moc data
const skeletonData: Skeleton[] = [
  {
    theme: 'light',
    baseColor: '#eee',
    waveColor: '#e1e1e1',
  },
  {
    theme: 'dark',
    baseColor: '#262626',
    waveColor: '#404040',
  },
];

export function getSkeletonColorsByTheme(themeEditorColor: EditorColorScheme) {
  const defaultSkeleton: Skeleton = {
    theme: 'light',
    baseColor: '#f0f0f0',
    waveColor: '#e1e1e1',
  };
  const foundSkeleton = skeletonData.find((skeleton) => skeleton.theme === themeEditorColor);
  return foundSkeleton || defaultSkeleton;
}
